export default __webpack_public_path__ + "static/media/once-upon-a-time.4040e9c0.jpg";